export enum EFeatureEventName {
  FEATURE_VIEWED = 'Feature Viewed',
}

export enum EFeatureSource {
  LISTING_TILE = 'Listing Tile',
  LISTING_HEADER = 'Listing Header',
  SEARCH_MAP = 'Search Map',
}

export enum EFeatureName {
  PRO_BADGE = 'Pro Badge',
  MILITARY_HOST_BADGE = 'Military Host Badge',
  PARTNER_HOST_BADGE = 'Partner Host Badge',
}

export interface IProBadgeHoveredEvent {
  featureName: EFeatureName;
  source: EFeatureSource;
  rentalID?: number;
}
